import { ACCESS } from "@dictybase/auth-mui5"
import { Publications } from "../../features/Publication/Publications"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default Publications
export const access = ACCESS.public
